{#snippet content}
  {#if icon}
    <ui-icon icon={icon}></ui-icon>
  {/if}
  {>slot}
  {#if badge}
    <ui-label outline badge>
      {badge}
    </ui-label>
  {/if}
{/snippet}

{#if href}
  <a class="{uiClasses}item" href="{href}" part="item">
    {>content}
  </a>
{else}
  <div class="{uiClasses}item" part="item">
    {>content}
  </div>
{/if}
